import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import pageT from "../i18n/pageTranslations";

const SUPPORTED_LANGS = ["ko", "en", "ja", "ru", "de"];
const DEFAULT_LANG = "ko";

const siteT = {
  ko: {
    // Navbar
    products: "제품",
    aiRecommend: "AI 추천",
    rental: "전국렌탈",
    store: "스토어",
    inquiry: "상담",
    compare: "제품 비교",
    reviewLounge: "리뷰라운지",
    search: "검색",
    wishlist: "관심목록",
    cart: "장바구니",
    login: "로그인",
    logout: "로그아웃",
    admin: "관리",
    myErp: "마이ERP",
    adminPage: "관리자 페이지",
    productCompare: "제품비교",
    sitemap: "사이트맵",
    // Footer / common
    contactUs: "문의하기",
    companyName: "일광오피스",
    allRightsReserved: "All rights reserved.",
    termsOfService: "이용약관",
    privacyPolicy: "개인정보처리방침",
    // Common actions
    submit: "전송",
    cancel: "취소",
    confirm: "확인",
    save: "저장",
    delete: "삭제",
    edit: "수정",
    close: "닫기",
    back: "뒤로",
    next: "다음",
    previous: "이전",
    loading: "로딩 중...",
    noData: "데이터가 없습니다",
    // Language picker
    language: "언어",
    langName: "한국어",
    aiTools: "비용분석 AI",
    b2bInquiry: "B2B 비즈니스 문의",
  },
  en: {
    products: "Products",
    aiRecommend: "AI Recommend",
    rental: "Rental",
    store: "Store",
    inquiry: "Consult",
    compare: "Compare",
    reviewLounge: "Review Lounge",
    search: "Search",
    wishlist: "Wishlist",
    cart: "Cart",
    login: "Login",
    logout: "Logout",
    admin: "Admin",
    myErp: "My ERP",
    adminPage: "Admin Page",
    productCompare: "Compare",
    sitemap: "Sitemap",
    contactUs: "Contact Us",
    companyName: "Ilkwang Office",
    allRightsReserved: "All rights reserved.",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
    submit: "Submit",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    loading: "Loading...",
    noData: "No data",
    language: "Language",
    langName: "English",
    aiTools: "AI Tools",
    b2bInquiry: "B2B Business Inquiry",
  },
  ja: {
    products: "製品",
    aiRecommend: "AI おすすめ",
    rental: "レンタル",
    store: "ストア",
    inquiry: "相談",
    compare: "比較",
    reviewLounge: "レビューラウンジ",
    search: "検索",
    wishlist: "お気に入り",
    cart: "カート",
    login: "ログイン",
    logout: "ログアウト",
    admin: "管理",
    myErp: "マイERP",
    adminPage: "管理ページ",
    productCompare: "製品比較",
    sitemap: "サイトマップ",
    contactUs: "お問い合わせ",
    companyName: "一光オフィス",
    allRightsReserved: "All rights reserved.",
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    submit: "送信",
    cancel: "キャンセル",
    confirm: "確認",
    save: "保存",
    delete: "削除",
    edit: "編集",
    close: "閉じる",
    back: "戻る",
    next: "次へ",
    previous: "前へ",
    loading: "読み込み中...",
    noData: "データなし",
    language: "言語",
    langName: "日本語",
    aiTools: "AIツール",
    b2bInquiry: "B2Bお問い合わせ",
  },
  ru: {
    products: "Продукция",
    aiRecommend: "AI Рекомендации",
    rental: "Аренда",
    store: "Магазин",
    inquiry: "Консультация",
    compare: "Сравнение",
    reviewLounge: "Зал обзоров",
    search: "Поиск",
    wishlist: "Избранное",
    cart: "Корзина",
    login: "Войти",
    logout: "Выйти",
    admin: "Админ",
    myErp: "Мой ERP",
    adminPage: "Панель админа",
    productCompare: "Сравнение",
    sitemap: "Карта сайта",
    contactUs: "Связаться",
    companyName: "Ilkwang Office",
    allRightsReserved: "Все права защищены.",
    termsOfService: "Условия использования",
    privacyPolicy: "Политика конфиденциальности",
    submit: "Отправить",
    cancel: "Отмена",
    confirm: "Подтвердить",
    save: "Сохранить",
    delete: "Удалить",
    edit: "Редактировать",
    close: "Закрыть",
    back: "Назад",
    next: "Далее",
    previous: "Назад",
    loading: "Загрузка...",
    noData: "Нет данных",
    language: "Язык",
    langName: "Русский",
    aiTools: "ИИ инструменты",
    b2bInquiry: "B2B запрос",
  },
  de: {
    products: "Produkte",
    aiRecommend: "AI Empfehlung",
    rental: "Miete",
    store: "Shop",
    inquiry: "Beratung",
    compare: "Vergleich",
    reviewLounge: "Bewertungs-Lounge",
    search: "Suche",
    wishlist: "Merkliste",
    cart: "Warenkorb",
    login: "Anmelden",
    logout: "Abmelden",
    admin: "Admin",
    myErp: "Mein ERP",
    adminPage: "Admin-Seite",
    productCompare: "Vergleich",
    sitemap: "Seitenplan",
    contactUs: "Kontakt",
    companyName: "Ilkwang Office",
    allRightsReserved: "Alle Rechte vorbehalten.",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutz",
    submit: "Senden",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    save: "Speichern",
    delete: "Löschen",
    edit: "Bearbeiten",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    loading: "Laden...",
    noData: "Keine Daten",
    language: "Sprache",
    langName: "Deutsch",
    aiTools: "KI-Tools",
    b2bInquiry: "B2B Anfrage",
  },
};

const LANG_OPTIONS = [
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("site_lang");
    if (SUPPORTED_LANGS.includes(saved)) return saved;
    // Auto-detect from browser language
    const browserLang = (navigator.language || "").slice(0, 2).toLowerCase();
    return SUPPORTED_LANGS.includes(browserLang) ? browserLang : DEFAULT_LANG;
  });

  const setLang = (code) => {
    if (SUPPORTED_LANGS.includes(code)) {
      setLangState(code);
      localStorage.setItem("site_lang", code);
      document.documentElement.lang = code;
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useMemo(() => ({
    ...(siteT[lang] || siteT.ko),
    ...(pageT[lang] || pageT.ko),
  }), [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, LANG_OPTIONS }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
